export enum ELanguages {
  fr
}
